/**
 * @generated SignedSource<<aab4c21b77461656be8e7f55fdded6ff>>
 * @relayHash 88ed8af64ac7185a0999b8c6bf0f12bf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 17357ad13472c97d7073c2a1eb4b600d98011b17893ba0a316e9e5de283bfc82

import type { ConcreteRequest } from 'relay-runtime';
export type InvokeExtensionInput = {
  async?: boolean | null;
  contextIds: ReadonlyArray<string>;
  entryPoint?: string | null;
  extensionDetails?: ExtensionDetailsInput | null;
  extensionId?: string | null;
  oAuthScopes?: ReadonlyArray<string> | null;
  payload: AGG$JSON;
  productEventScopes?: ReadonlyArray<string> | null;
};
export type ExtensionDetailsInput = {
  definitionId: string;
  extensionKey: string;
};
export type useInvokeExtensionRelayMutation$variables = {
  input: InvokeExtensionInput;
};
export type useInvokeExtensionRelayMutation$data = {
  readonly invokeExtension: {
    readonly contextToken: {
      readonly expiresAt: string;
      readonly jwt: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly fields?: {
          readonly authInfoUrl: string | null;
        } | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly rateLimitProperties: {
      readonly rateLimitRemaining: number | null;
      readonly rateLimitReset: number | null;
      readonly rateLimitValue: number | null;
    } | null;
    readonly response: {
      readonly body: AGG$JSON;
    } | null;
    readonly success: boolean;
  } | null;
};
export type useInvokeExtensionRelayMutation = {
  response: useInvokeExtensionRelayMutation$data;
  variables: useInvokeExtensionRelayMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "InvocationResponsePayload",
  "kind": "LinkedField",
  "name": "response",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "body"
    }
  ]
},
v4 = {
  "concreteType": "ForgeContextToken",
  "kind": "LinkedField",
  "name": "contextToken",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jwt"
    },
    {
      "kind": "ScalarField",
      "name": "expiresAt"
    }
  ]
},
v5 = {
  "concreteType": "RateLimitProperties",
  "kind": "LinkedField",
  "name": "rateLimitProperties",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "rateLimitRemaining"
    },
    {
      "kind": "ScalarField",
      "name": "rateLimitReset"
    },
    {
      "kind": "ScalarField",
      "name": "rateLimitValue"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v8 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v9 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InvokeExtensionPayloadErrorExtensionFields",
      "kind": "LinkedField",
      "name": "fields",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "authInfoUrl"
        }
      ]
    }
  ],
  "type": "InvokeExtensionPayloadErrorExtension"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useInvokeExtensionRelayMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InvokeExtensionResponse",
        "kind": "LinkedField",
        "name": "invokeExtension",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInvokeExtensionRelayMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "InvokeExtensionResponse",
        "kind": "LinkedField",
        "name": "invokeExtension",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "17357ad13472c97d7073c2a1eb4b600d98011b17893ba0a316e9e5de283bfc82",
    "metadata": {},
    "name": "useInvokeExtensionRelayMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7da04c6e6467fec1087d3d61ffac8358";

export default node;
